import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import IconaServizio from '../components/IconaServizio';
import { serviziPerUtente } from '../servizi';
import './Hub.css';

// Pagina iniziale degli utenti studio: le schede dei servizi.
// È solo navigazione: i permessi veri li controlla il server.
export default function Hub() {
  const { utente } = useAuth();
  const navigate = useNavigate();
  const servizi = serviziPerUtente(utente);

  const ora = new Date().getHours();
  const saluto = ora < 13 ? 'Buongiorno' : ora < 18 ? 'Buon pomeriggio' : 'Buonasera';

  const apri = (s) => {
    if (!s.cliccabile) return;
    navigate(s.consentito ? s.percorso : '/accesso-negato');
  };

  return (
    <Layout larga>
      <div className="hub">
        <h2 className="hubSaluto">{saluto}, {utente.nome}</h2>
        <p className="hubSotto">Scegli il servizio</p>
        <div className="hubGriglia">
          {servizi.map(s => (
            <button
              key={s.chiave}
              type="button"
              onClick={() => apri(s)}
              disabled={!s.cliccabile}
              className={`hubScheda ${s.cliccabile && !s.consentito ? 'hubSchedaBloccata' : ''} ${s.cliccabile ? '' : 'hubSchedaInArrivo'}`}
              aria-label={`${s.nomeScheda || s.nome}${!s.consentito ? ' (non consentito)' : ''}${s.stato === 'in_arrivo' ? ' (in arrivo)' : ''}`}
            >
              <span className="hubIcona"><IconaServizio icona={s.icona} dimensione={34} /></span>
              <span className="hubNome">
                {s.nomeScheda || s.nome}
                {s.cliccabile && !s.consentito && <IconaServizio icona="lucchetto" dimensione={16} className="hubLucchetto" />}
              </span>
              {s.descrizione && <span className="hubDescrizione">{s.descrizione}</span>}
              {s.stato === 'in_arrivo' && <span className="hubEtichetta">In arrivo</span>}
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
}
